export const BOSS_IMAGE_MAPPING = {
  "Mano": "https://legends.ml/static/images/lib/monster/2220000.png",
  "Stumpy": "https://legends.ml/static/images/lib/monster/3220000.png",
  "Deo": "https://legends.ml/static/images/lib/monster/3220001.png",
  "King Clang": "https://legends.ml/static/images/lib/monster/5220000.png",
  "Seruf": "https://legends.ml/static/images/lib/monster/4220001.png",
  "Faust": "https://legends.ml/static/images/lib/monster/5220002.png",
  "Giant Centipede": "https://legends.ml/static/images/lib/monster/9500177.png",
  "Timer": "https://legends.ml/static/images/lib/monster/5220003.png",
  "Mushmom": "https://legends.ml/static/images/lib/monster/6130101.png",
  "Dyle": "https://legends.ml/static/images/lib/monster/6220000.png",
  "Zombie Mushmom": "https://legends.ml/static/images/lib/monster/6300005.png",
  "Zeno": "https://legends.ml/static/images/lib/monster/6220001.png",
  "Nine-Tailed Fox": "https://legends.ml/static/images/lib/monster/7220001.png",
  "Tae Roon": "https://legends.ml/static/images/lib/monster/7220000.png",
  "King Sage Cat": "https://legends.ml/static/images/lib/monster/7220002.png",
  "Jr. Balrog": "https://legends.ml/static/images/lib/monster/8130100.png",
  "Eliza": "https://legends.ml/static/images/lib/monster/8220000.png",
  "Snack Bar": "https://legends.ml/static/images/lib/monster/9410015.png",
  "Chimera": "https://legends.ml/static/images/lib/monster/8220002.png",
  "Blue Mushmom": "https://legends.ml/static/images/lib/monster/9400205.png",
  "Snowman": "https://legends.ml/static/images/lib/monster/8220001.png",
  "Headless Horseman": "https://legends.ml/static/images/lib/monster/9400549.png",
  "Manon": "https://legends.ml/static/images/lib/monster/9500174.png",
  "Griffey": "https://legends.ml/static/images/lib/monster/8180001.png",
  "Pianus (16h)": "https://legends.ml/static/images/lib/monster/8510000.png",
  "Pianus (24h)": "https://legends.ml/static/images/lib/monster/8520000.png",
  "BigFoot": "https://legends.ml/static/images/lib/monster/9400575.png",
  "Black Crow": "https://legends.ml/static/images/lib/monster/9400014.png",
  "Leviathan": "https://legends.ml/static/images/lib/monster/8220003.png",
  "Kacchuu Musha": "https://legends.ml/static/images/lib/monster/9400405.png",
  "Dodo": "https://legends.ml/static/images/lib/monster/8220004.png",
  "Anego / Female Boss": "https://legends.ml/static/images/lib/monster/9400121.png",
  "Lilynouch": "https://legends.ml/static/images/lib/monster/8220005.png",
  "Lyka": "https://legends.ml/static/images/lib/monster/8220006.png",
  "Balrog": "https://royals-library.netlify.app/images/monsters/8830000.png",
  "Horntail": "https://legends.ml/static/images/lib/monster/8810003.png",
  "Zakum": "https://legends.ml/static/images/lib/monster/8800002.png",
  "Papulatus": "https://legends.ml/static/images/lib/monster/8500001.png",
  "Crimsonwood Keep Expedition CWKPQ": "https://legends.ml/static/images/lib/monster/9400661.png"
};

export const getBossImageUrl = (imageKeyOrName) => {
  if (!imageKeyOrName) return null;
  // If it's already a full URL, return it
  if (imageKeyOrName.startsWith("http")) return imageKeyOrName;
  // Otherwise look up from mapping
  return BOSS_IMAGE_MAPPING[imageKeyOrName] || null;
};
